function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.285 12.305l-2.578-2.594a1 1 0 00-1.416-.002L9 12 4 7l2.294-2.294a1 1 0 00.001-1.414L3.715.708a1 1 0 00-1.415 0L.004 3.003 0 3c0 7.18 5.82 13 13 13l2.283-2.283a1 1 0 00.002-1.412z",
  fill: "#F17071"
});

function SvgPhoneColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTE1LjI4NSAxMi4zMDVsLTIuNTc4LTIuNTk0YTEgMSAwIDAwLTEuNDE2LS4wMDJMOSAxMiA0IDdsMi4yOTQtMi4yOTRhMSAxIDAgMDAuMDAxLTEuNDE0TDMuNzE1LjcwOGExIDEgMCAwMC0xLjQxNSAwTC4wMDQgMy4wMDMgMCAzYzAgNy4xOCA1LjgyIDEzIDEzIDEzbDIuMjgzLTIuMjgzYTEgMSAwIDAwLjAwMi0xLjQxMnoiIGZpbGw9IiNGMTcwNzEiIGZpbGwtcnVsZT0ibm9uemVybyIvPgo8L3N2Zz4K";
export { SvgPhoneColor as ReactComponent };